import { Box } from '@everlywell/ui-kit';
import ProductComparisonModal from 'components/PDP/ProductComparisonModal';
import PDPOverviewSection from 'components/PDP/sections/PDPOverviewSection';
import React from 'react';

export interface ReviewsData {
  average_rating: number;
  review_count: number;
}

export type HeroSubsectionProps = {
  data: Queries.pdpSectionFragment;
  slug: string;
  product: Queries.pdpProductFragment;
  whatIsMeasuredData: Queries.PDPQuery['whatsMeasured']['nodes'][0];
};

/**
 * [Add the description for what this component does here].
 */
const HeroSubsection = (props: HeroSubsectionProps) => {
  const { data: section, slug, product, whatIsMeasuredData } = props;

  // TODO: refactor this logic for rendering modals based on slug
  const fsSlug = [
    'food-sensitivity',
    'food-sensitivity-comprehensive-test',
    'indoor-outdoor-allergy-test',
  ].includes(slug)
    ? slug
    : undefined;

  switch (section.componentName) {
    // TODO: remove this case as the overview section should not be allowed here
    case 'PDPOverviewSection':
      return (
        <Box as="section">
          <PDPOverviewSection
            {...section}
            slug={fsSlug}
            product={product}
            whatIsMeasuredData={whatIsMeasuredData}
          />
        </Box>
      );
    case 'ProductComparisonModal':
      return (
        <Box as="section">
          <ProductComparisonModal data={section} productData={product} />
        </Box>
      );
    default:
      return null;
  }
};

export default HeroSubsection;
